module.exports = __webpack_public_path__ + "img/4_Mobility_gender_frontcover.9b64fd60.jpg";